import React from "react";
import { Box, InputAdornment, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ErrorMessage, useField } from "formik";

const CustomInput = styled(TextField)({});

const CustomTextField = ({
    label,
    type,
    value,
    prepend,
    readOnly,
    bBottom,
    ...props
}) => {
    const [field, meta] = useField(props);
    return (
        <>
            <Box sx={{ marginTop: 2, borderRadius: 1.5, overflow: "hidden" }}>
                <CustomInput
                    error={meta.touched && meta.error ? true : false}
                    label={label}
                    variant="filled"
                    fullWidth
                    type={type}
                    placeholder={field.label}
                    {...field}
                    {...props}
                    InputProps={{
                        startAdornment: prepend && (
                            <InputAdornment position="start">
                                {prepend}
                            </InputAdornment>
                        ),
                        readOnly: readOnly ? true : false,
                    }}
                    sx={{
                        borderBottom: `1px solid red${bBottom} !important`,
                    }}
                />
                <ErrorMessage
                    component="span"
                    name={field.name}
                    className="error-text"
                />
            </Box>
        </>
    );
};

export default CustomTextField;
